import React, { FC } from 'react'

interface ComponentProps {
	erid: string
}

export const AdTooltipText: FC<ComponentProps> = ({ erid }) => {
	return (
		<>
			<p>Реклама. Рекламодатель ПАО Сбербанк.</p>
			<p>ИНН 7707083893</p>
			<p>erid: {erid}</p>
		</>
	)
}
